export function makeColumnDefs (browserAppAccount) {
  console.log('makeColumnDefs')

  const columnDefs = []
  columnDefs.push({
    headerName: 'Entity',
    field: 'tenantName'
  })

  columnDefs.push({
    headerName: 'Associate',
    valueGetter: function (cellParams) {
      const associatedEntities = browserAppAccount.data.entities
      const associatedEntity = associatedEntities.find(entity => entity.xero_id === cellParams.data.tenantId)
      return !!associatedEntity
    },
    cellRenderer: function (cellParams) {
      if (cellParams.value === true) return 'Already associated'

      return '<button class="button is-primary is-small is-flex" data-action="associate" data-xero-id="' + cellParams.data.tenantId + '">Associate</button>'
    },
    cellClass: ['is-flex', 'is-align-items-center'] // vertical align
  })

  columnDefs.push({
    headerName: 'Disconnect',
    valueGetter: function (cellParams) {
      // xero ConnectionID
      return cellParams.data.id
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      return '<button class="button is-danger is-light is-small is-flex" data-action="disconnect" data-connection-id="' + cellParams.value + '">Disconnect</button>'
    },
    cellClass: ['is-flex', 'is-align-items-center'] // vertical align
  })
  return columnDefs
}
